import { createSlice } from '@reduxjs/toolkit';

import { TCastingsClassifiers, TClassifiers } from '@/shared/types/classifiers';

interface IClassifiersState {
  general: TClassifiers;
  castings: TCastingsClassifiers;
}

const initialState: IClassifiersState = {
  general: {} as TClassifiers,
  castings: {} as TCastingsClassifiers
};

export const classifiersSlice = createSlice({
  name: 'classifiers',
  initialState,
  reducers: {
    /**
     * Обновление общих классификаторов
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Пейлоад экшена
     */
    updateGeneral: (state, { payload }) => ({
      ...state,
      general: { ...state.general, ...payload }
    }),
    /**
     * Обновление классификаторов кастингов
     * @param state Состояние
     * @param root0 Экшен
     * @param root0.payload Пейлоад экшена
     */
    updateCastings: (state, { payload }) => ({
      ...state,
      castings: { ...state.castings, ...payload }
    }),
    /** Удаление данных classifiers */
    reset: () => initialState
  }
});

export const {
  updateGeneral: updateGeneralClassifiers,
  updateCastings: updateCastingsClassifiers,
  reset: resetClassifiers
} = classifiersSlice.actions;
export const { reducer: classifiersReducer } = classifiersSlice;
